export default __webpack_public_path__ + "static/media/lifebar3.54f8561f.PNG";